export default __webpack_public_path__ + "static/media/guyportrait.dde2a99d.jpg";